import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import TextField from '../TextField';
import SelectTextField from '../SelectTextField';
import { zipCodeInputValidator } from '../../../core/util/rcForm/validators';
import { stripNonNumeric } from '../../../core/util/string';
import { STATE_CODES } from '../../../constants/index';
import { safeGet } from '../../../core/util/object';
import { emptyFunction } from '../../../core/util/function';

const MediumInputContainer = styled(Grid).withConfig({ componentId: 'sc-cuds7b-0' })`
  max-width: 48%;
  flex-basis: 48%;
  margin: 5px 0;
`;
const LargeInputContainer = styled(Grid).withConfig({ componentId: 'sc-cuds7b-1' })`
  margin: 5px auto;
`;

const Container = styled.div.withConfig({ componentId: 'sc-cuds7b-2' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const getStates = () => [
  { key: '', label: '', value: '' },
  ...STATE_CODES.map((stateCode) => ({
    key: stateCode.toUpperCase(),
    label: stateCode.toUpperCase(),
    value: stateCode.toUpperCase(),
  })),
];

type OwnHomeAddressProps = {
  errors?: any;
  form: any;
  onBlur?: (...args: any[]) => any;
  onFieldChange?: (...args: any[]) => any;
  userProfile?: any;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'HomeAddressProps' circularly reference... Remove this comment to see the full error message
type HomeAddressProps = OwnHomeAddressProps & typeof HomeAddress.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'HomeAddress' implicitly has type 'any' because it... Remove this comment to see the full error message
const HomeAddress = (props: HomeAddressProps) => {
  const { errors, form, onBlur, onFieldChange, userProfile } = props;

  return (
    <>
      <LargeInputContainer item xs={12}>
        <TextField
          id="address_street"
          {...form.getFieldProps('address_street', {
            rules: [{ required: true, whitespace: true }],
            initialValue: (userProfile && userProfile.address_street) || '',
          })}
          data-hj-suppress
          data-testid="address"
          error={Boolean(safeGet(errors)('address_street'))}
          fullWidth
          label="Address"
          onBlur={() => onBlur('address_street')}
        />
      </LargeInputContainer>

      <LargeInputContainer item xs={12}>
        <TextField
          id="address_street_secondary"
          {...form.getFieldProps('address_street_secondary', {
            initialValue: (userProfile && userProfile.address_street_secondary) || '',
          })}
          data-hj-suppress
          data-testid="address2"
          error={Boolean(safeGet(errors)('address_street_secondary'))}
          fullWidth
          label="Address 2"
          onBlur={() => onBlur('address_street_secondary')}
        />
      </LargeInputContainer>

      <LargeInputContainer item xs={12}>
        <TextField
          id="address_city"
          {...form.getFieldProps('address_city', {
            rules: [{ required: true, whitespace: true }],
            initialValue: (userProfile && userProfile.address_city) || '',
          })}
          data-hj-suppress
          data-testid="city"
          error={Boolean(safeGet(errors)('address_city'))}
          fullWidth
          label="City"
          onBlur={() => onBlur('address_city')}
        />
      </LargeInputContainer>

      <Container>
        <MediumInputContainer item xs={6}>
          <SelectTextField
            id="address_state"
            {...form.getFieldProps('address_state', {
              rules: [{ required: true }],
              initialValue: (userProfile && userProfile.address_state) || '',
            })}
            data-hj-suppress
            data-testid="state"
            error={Boolean(safeGet(errors)('address_state'))}
            fullWidth
            label="State"
            onBlur={() => onBlur('address_state')}
            selectOptions={getStates()}
          />
        </MediumInputContainer>

        <MediumInputContainer item xs={6}>
          <TextField
            id="address_zip"
            {...form.getFieldProps('address_zip', {
              rules: [{ required: true, validator: zipCodeInputValidator, len: 5 }],
              initialValue: (userProfile && userProfile.address_zip) || '',
            })}
            data-hj-suppress
            data-testid="zip"
            error={Boolean(safeGet(errors)('address_zip'))}
            fullWidth
            inputProps={{
              maxLength: 5,
              pattern: '[0-9]*',
              inputMode: 'numeric',
            }}
            label="ZIP code"
            onBlur={({ target: { value } }: any) =>
              onFieldChange(stripNonNumeric(value), 'address_zip')
            }
          />
        </MediumInputContainer>
      </Container>
    </>
  );
};

HomeAddress.defaultProps = {
  onBlur: emptyFunction,
  onFieldChange: emptyFunction,
};

export default HomeAddress;
